import { z } from "zod";

const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export const timeEntrySchema = z
	.object({
		mode: z.enum(["create", "edit"]),
		workerId: z.string(),
		workDate: z.date().optional(),
		clockedInAt: z
			.string()
			.regex(TIME_PATTERN, { message: "Use o formato HH:MM" }),
		clockedOutAt: z.union([
			z.string().regex(TIME_PATTERN, { message: "Use o formato HH:MM" }),
			z.literal(""),
		]),
		editNote: z
			.string()
			.trim()
			.min(1, { message: "Descreva o motivo do ajuste" }),
	})
	.superRefine((data, ctx) => {
		if (data.mode === "create" && !data.workerId) {
			ctx.addIssue({
				code: "custom",
				message: "Selecione uma pessoa",
				path: ["workerId"],
			});
		}
		if (data.mode === "create" && !data.workDate) {
			ctx.addIssue({
				code: "custom",
				message: "Informe o dia",
				path: ["workDate"],
			});
		}
		if (data.clockedOutAt && data.clockedOutAt <= data.clockedInAt) {
			ctx.addIssue({
				code: "custom",
				message: "A saída deve ser depois da entrada",
				path: ["clockedOutAt"],
			});
		}
	});

export type TimeEntryFormValues = z.infer<typeof timeEntrySchema>;
